const LOCAL_DOMAINS = ['localhost', '127.0.0.1', ''];

/**
 * Whether or not the app is running in the local environment
 */
export const isLocal = LOCAL_DOMAINS.includes(window.location.hostname);
